












import ReturnToPlanListButton from '@spa/components/pages/paid-membership/change/model/page/form/components/ReturnToPlanListButton.vue'
import Vue from 'vue'
import { Component, Emit } from 'vue-property-decorator'

@Component({
  components: { ReturnToPlanListButton },
})
export default class AllowedToChange extends Vue {
  @Emit('change')
  onClick() {
    // only emit event
  }
}
